
/*
 * Get first address component by type
 *
 * @param   {Object} address_components[] - Set of addresses
 * @param   {String} component_type       - Type to retrieve
 * @returns {Object|undefined}            - First address result matching type
 */
var getAddressComponentType, getAlternateAddressFormat;

getAddressComponentType = function(arg, component_type) {
  var address_components;
  address_components = arg.address_components;
  return _.find(address_components, function(arg1) {
    var types;
    types = arg1.types;
    return _.some(types, function(type) {
      return type === component_type;
    });
  });
};


/*
 * Get address name
 *
 * @param   {Object} result                      - Google maps result object
 * @param   {Array}  result.address_components[] - Array with address_components describing result
 * @param   {String} result.formatted_address    - Localized nice name for result
 * @returns {String}
 */

getAlternateAddressFormat = function(result) {
  var address;
  if ((address = getAddressComponentType(result, 'sublocality_level_1')) != null) {
    return address.short_name;
  } else if ((address = getAddressComponentType(result, 'locality')) != null) {
    return address.long_name;
  } else if ((address = getAddressComponentType(result, 'administrative_area_level_1')) != null) {
    return address.short_name;
  } else {
    return result.formatted_address;
  }
};

module.exports = {
  getAddressComponentType: getAddressComponentType,
  getAlternateAddressFormat: getAlternateAddressFormat
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL2dlbmVyYWwvc3BlY2lhbEFkZHJlc3NDb21wb25lbnRUeXBlLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9nZW5lcmFsL3NwZWNpYWxBZGRyZXNzQ29tcG9uZW50VHlwZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7O0FBQUEsSUFBQTs7QUFPQSx1QkFBQSxHQUEwQixTQUFDLEdBQUQsRUFBdUIsY0FBdkI7QUFDeEIsTUFBQTtFQUQwQixxQkFBRDtTQUN6QixDQUFDLENBQUMsSUFBRixDQUFPLGtCQUFQLEVBQTJCLFNBQUMsSUFBRDtBQUN6QixRQUFBO0lBRDJCLFFBQUQ7V0FDMUIsQ0FBQyxDQUFDLElBQUYsQ0FBTyxLQUFQLEVBQWMsU0FBQyxJQUFEO2FBQVUsSUFBQSxLQUFRO0lBQWxCLENBQWQ7RUFEeUIsQ0FBM0I7QUFEd0I7OztBQUkxQjs7Ozs7Ozs7O0FBUUEseUJBQUEsR0FBNEIsU0FBQyxNQUFEO0FBQzFCLE1BQUE7RUFBQSxJQUFHLDBFQUFIO1dBQ0UsT0FBTyxDQUFDLFdBRFY7R0FBQSxNQUVLLElBQUcsK0RBQUg7V0FDSCxPQUFPLENBQUMsVUFETDtHQUFBLE1BRUEsSUFBRyxrRkFBSDtXQUNILE9BQU8sQ0FBQyxXQURMO0dBQUEsTUFBQTtXQUdILE1BQU0sQ0FBQyxrQkFISjs7QUFMcUI7O0FBVTVCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2YseUJBQUEsdUJBRGU7RUFFZiwyQkFBQSx5QkFGZSJ9
